var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLightbulb = function SvgLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.063 30.662h11.874M14 26.157v-7.884M9.25 13.768 14 18.273l4.75-4.505",
    stroke: "#2F2F2F",
    strokeWidth: 1.781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.683 21.512a11.382 11.382 0 0 1-3.345-3.907 10.77 10.77 0 0 1-1.213-4.9C2.09 6.6 7.28 1.525 13.714 1.382a12.343 12.343 0 0 1 7 1.97c2.057 1.337 3.618 3.255 4.462 5.481.843 2.227.926 4.648.236 6.922-.689 2.273-2.116 4.283-4.077 5.745a3.464 3.464 0 0 0-1.025 1.188c-.242.465-.37.976-.372 1.494v.848c0 .3-.126.586-.348.797-.223.211-.525.33-.84.33h-9.5c-.315 0-.617-.119-.84-.33a1.098 1.098 0 0 1-.348-.797v-.849a3.25 3.25 0 0 0-.365-1.485 3.435 3.435 0 0 0-1.014-1.184v0Z",
    stroke: "#2F2F2F",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgLightbulb;